module.exports = __webpack_public_path__ + "static/media/Transaction.ba334e93.svg";